import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import type { RoleStatuses } from "~enums/roleStatuses";
import type { Roles } from "~enums/roles";
import type { RoleResponse } from "~types/role";
import { useApi } from "./useApi";

export type UpdateRole = {
  roleId: string;
  status?: RoleStatuses;
  role?: Roles;
};

export const useUpdateRole = (options: UseMutationOptions<RoleResponse, unknown, UpdateRole, unknown> = {}) => {
  const request = useApi();
  const { sport, organizationId } = useParams();

  if (!sport || !organizationId) {
    console.error({ sport, organizationId });
    throw new Error("Missing required params");
  }

  return useMutation({
    mutationFn: ({ roleId, ...body }: UpdateRole) =>
      request<RoleResponse>(`${sport}/o/${organizationId}/roles/${roleId}`, {
        method: "PUT",
        body,
      }),
    ...options,
  });
};
